<template>
    <div class="page-table haberTanim  mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">Hasta Bilgileri</div>
        <el-row :gutter="10">
            <el-form label-position="top" status-icon :model="hastaForm" :rules="rulesHasta" ref="hastaForm"
                     class="demo-ruleForm">
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <el-row>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='T.C. No : ' prop="tcNo">
                                    <el-input
                                            v-model="hastaForm.tcNo" v-mask="'###########'"
                                            placeholder='T.C. No Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='İsim Soyisim :' prop="adSoyad">
                                    <el-input
                                            v-model="hastaForm.adSoyad"
                                            v-on:input="inputStyleAlt(hastaForm.adSoyad)"
                                            placeholder='İsim Soyisim Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Yaş :' prop="yas">
                                    <el-input
                                            v-model="hastaForm.yas"
                                            v-mask="'##'"
                                            placeholder='Yaş Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='İl :' prop="il">
                                    <el-select
                                            v-model="hastaForm.il"
                                            filterable
                                            placeholder='İl Seçiniz'
                                            style="width: 100%">
                                        <el-option v-for="item in ilList"
                                                   :key="item.baslik"
                                                   :label="item.baslik"
                                                   :value="item.ilId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Telefon :' prop="telefon">
                                    <el-input
                                            v-model="hastaForm.telefon"
                                            v-mask="'+90(###)### ## ##'"
                                            placeholder='Telefon Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='E-Posta :' prop="eposta">
                                    <el-input
                                            type="email"
                                            v-model="hastaForm.eposta"
                                            placeholder='E-Posta Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="8" :md="8" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Cinsiyet :' prop="cinsiyet">
                                    <div>
                                        <el-radio style="width: 46.5%" v-model="hastaForm.cinsiyet" label="Kadın"
                                                  border
                                                  size="medium">
                                            <i style="color: deeppink;" class="mdi mdi-human-female"></i> Kadın
                                        </el-radio>
                                        <el-radio style="width: 46.5%; margin-left: 0 !important;"
                                                  v-model="hastaForm.cinsiyet" label="Erkek"
                                                  border
                                                  size="medium">
                                            <i style="color: #337ab7;" class="mdi mdi-human-male"></i> Erkek
                                        </el-radio>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :lg="24" :md="24" :sm="24" :xs="24">
                    <div class="card-base baslikBg animated fadeInUp margin-top-10">Hekim Bilgileri</div>
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">

                        <el-row v-for="(itemD,indexD) in hastaForm.hekim" class="margin-top-10  animated fadeInLeft">
                            <el-col :lg="1" :md="1" :sm="24" :xs="24" class="col-p">
                                <div class="margin-top-30">
                                    <el-button v-on:click="dialogVisibleHekim=true" size="mini" plain
                                               type="warning" icon="el-icon-plus" class="mobil-doktor-buton">
                                    </el-button>
                                </div>
                            </el-col>
                            <el-col :lg="7" :md="7" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Hekim Adı : ' prop="hekimId">
                                    <el-select
                                            v-model="itemD.hekimId"
                                            v-on:change="doktorTespit(itemD.hekimId,indexD)"
                                            filterable
                                            placeholder='Hekim Seçiniz'
                                            style="width: 100%">
                                        <el-option v-for="item in hekimList"
                                                   :key="item.hekimId"
                                                   :label="item.adSoyad"
                                                   :value="item.hekimId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="7" :md="7" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='Telefon :' prop="doktorTelefon">
                                    <el-input
                                            :disabled="itemD.hekimId === ''"
                                            v-model="itemD.doktorTelefon" v-mask="'+90(###)### ## ##'"
                                            placeholder='Telefon Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="7" :md="7" :sm="24" :xs="24" class="col-p">
                                <el-form-item label='E-Posta :' prop="doktorEposta">
                                    <el-input
                                            :disabled="itemD.hekimId === ''"
                                            v-model="itemD.doktorEposta"
                                            placeholder='E-Posta Giriniz'></el-input>
                                </el-form-item>
                            </el-col>
                            <!--                                <el-col :lg="5" :md="5" :sm="24" :xs="24" class="col-p">-->
                            <!--                                    <el-form-item label='Klinik :' prop="klinik">-->
                            <!--                                        <el-select-->
                            <!--                                                :disabled="itemD.doktorAdi === ''"-->
                            <!--                                                v-model="itemD.klinik"-->
                            <!--                                                filterable-->
                            <!--                                                placeholder='Klinik Seçiniz'-->
                            <!--                                                style="width: 100%">-->
                            <!--                                            <el-option v-for="item in klinikList"-->
                            <!--                                                       :key="item.klinikId"-->
                            <!--                                                       :label="item.baslik"-->
                            <!--                                                       :value="item.klinikId"></el-option>-->
                            <!--                                        </el-select>-->
                            <!--                                    </el-form-item>-->
                            <!--                                </el-col>-->
                            <el-col :lg="2" :md="2" :sm="24" :xs="24" class="col-p text-center">
                                <div class="margin-top-30">
                                    <el-button v-if="indexD+1 === hastaForm.hekim.length" @click="doktorEkle" size="mini" plain
                                               type="primary" icon="el-icon-plus" class="mobil-doktor-buton">
                                    </el-button>
                                    <el-button v-else @click="removedoktor(indexD)" size="mini" plain
                                               type="danger" icon="el-icon-minus" class="mobil-doktor-buton">
                                    </el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </div>


                    <div style="text-align: right; margin-top: 10px">
                        <el-button size="mini" icon="el-icon-edit" class="estas-buton" type="primary"
                                   @click="hastaGuncelleme('hastaForm')">Hasta Güncelle
                        </el-button>
                        <el-button size="mini" class="estas-buton-border" icon="el-icon-circle-close" @click="resetForm('hastaForm')">Vazgeç</el-button>
                    </div>


                </el-col>
            </el-form>

        </el-row>
        <hekim-tanimlama v-if="dialogVisibleHekim" :dialogvisible.sync="dialogVisibleHekim"></hekim-tanimlama>

    </div>

</template>

<script>
    import EventBus from '@/components/event-bus'

    import HekimTanimlama from '@/components/HekimTanimlama'
    import hekimService from '../../../WSProvider/HekimService'
    import hastaService from '../../../WSProvider/HastaService'
    import ilService from '../../../WSProvider/IlService'
    import yoneticiService from '../../../WSProvider/YoneticiService'

    import notification from '../../../notification'

    var base64 = require('base64_js');
    export default {
        name: "HastaGuncelleme",
        components: {
            HekimTanimlama
        },
        data() {
            return {
                updateId: '',
                hastaHekimId: '',
                dialogVisibleHekim: false,
                updateData: [],
                hastaKlon: [],
                ilList: [],
                klinikList: [],
                urunList: [],
                ekUrunList: [],
                ekTedaviList: [],
                hekimList: [],

                dateRangeOptions: {
                    firstDayOfWeek: 1
                },
                hastaForm: {
                    tcNo: '',
                    adSoyad: '',
                    yas: '',
                    cinsiyet: '',
                    telefon: '',
                    eposta: '',
                    il: '',

                    hekim: [{
                        hekimId: '',
                        doktorTelefon: '',
                        doktorEposta: '',
                        klinik: '',
                    }],


                },
                rulesHasta: {
                    tcNo: [{
                        required: true,
                        message: "Lütfen T.C. No Giriniz",
                        trigger: 'blur'
                    }],
                    adSoyad: [{
                        required: true,
                        message: "Lütfen İsim Soyisim Giriniz.",
                        trigger: 'change'
                    }],
                    yas: [{
                        required: true,
                        message: "Lütfen Yaş Seçiniz.",
                        trigger: 'change'
                    }],
                    cinsiyet: [{
                        required: true,
                        message: "Lütfen Cinsiyet Seçiniz.",
                        trigger: 'change'
                    }],
                    telefon: [{
                        required: true,
                        message: "Lütfen Telefon Seçiniz.",
                        trigger: 'change'
                    }],
                    il: [{
                        required: true,
                        message: "Lütfen İl Seçiniz.",
                        trigger: 'change'
                    }],
                    // hekimId: [{
                    //     required: true,
                    //     message: "Lütfen Hekim Seçiniz.",
                    //     trigger: 'change'
                    // }],
                    // doktorTelefon: [{
                    //     required: true,
                    //     message: "Lütfen Telefon Giriniz.",
                    //     trigger: 'change'
                    // }],
                    // doktorEposta: [{
                    //     required: true,
                    //     message: "Lütfen E-Posta Giriniz.",
                    //     trigger: 'change'
                    // }],
                    // klinik: [{
                    //     required: true,
                    //     message: "Lütfen Klinik Seçiniz.",
                    //     trigger: 'change'
                    // }]
                },
            }
        },
        mounted() {
            let self = this;
            this.updateId = this.$store.state.updateKodu;
            this.getHastaDetay();
            if (localStorage.getItem("userData3H")) {
                var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                if (userData3H["tur"]) {
                    if (userData3H["tur"] === '1') {
                        this.getIl();
                    } else if (userData3H["tur"] === '2') {
                        this.getIl();
                    } else if (userData3H["tur"] === '3') {
                        this.getIlYonetici();
                    } else if (userData3H["tur"] === '4') {
                        this.getIlYonetici();
                    } else if (userData3H["tur"] === '5') {
                        this.getIlYonetici();
                    }
                }

            }
            EventBus.$on('hekimList', function (bool) {
                if (bool) {
                    self.getHekimList();
                }
            });
        },
        methods: {
            doktorEkle() {
                this.hastaForm.hekim.push({
                    hekimId: '',
                    doktorTelefon: '',
                    doktorEposta: '',
                    klinik: '',
                });
            },
            removedoktor(item) {
                this.hastaForm.hekim.splice(item, 1);
            },
            inputStyleAlt(val) {
                var splitStr = val.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
                }
                this.hastaForm.adSoyad = splitStr.join(' ');
            },
            getHastaDetay() {
                hastaService.hastaDetay(this.updateId).then((response) => {
                    if (response.status === 200) {
                        this.hastaHekimId = response.data.hekimId;
                        this.getIl();
                        console.log(response.data)
                        this.getHekimList();
                        this.hastaForm = {
                            tcNo: response.data.tcNo,
                            adSoyad: response.data.adSoyad,
                            yas: response.data.yas,
                            cinsiyet: response.data.cinsiyet,
                            telefon: response.data.telefon,
                            eposta: response.data.eposta,
                            il: response.data.ilId,
                            hekim: response.data.hekim,
                        };
                        this.hastaKlon = {
                            tcNo: response.data.tcNo,
                            adSoyad: response.data.adSoyad,
                            yas: response.data.yas,
                            cinsiyet: response.data.cinsiyet,
                            telefon: response.data.telefon,
                            eposta: response.data.eposta,
                            il: response.data.ilId,
                            hekim: response.data.hekim,
                        }
                    }
                })
            },
            getIl() {
                ilService.il().then((response) => {
                    if (response.status === 200) {
                        this.ilList = response.data;
                    } else notification.Status(response.status, this)
                })

            },
            getIlYonetici() {
                var userData3H = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData3H"))));
                yoneticiService.yonetimIlList(userData3H["yonetimKodu"]).then((response) => {
                    if (response.status === 200) {
                        this.ilList = response.data;
                    }
                })

            },
            getHekimList() {
                let self = this;
                hekimService.hekimList(1, '', '').then((response) => {
                    if (response.status === 200) {
                        // this.hekimList = response.data;
                        response.data.forEach(function (e) {
                            var obj = self.hekimList.find(data => data.hekimId === e.hekimId);
                            if (obj === undefined) {
                                self.hekimList.push(e)
                            }
                        });

                        this.doktorTespit(this.hastaHekimId, 0)
                    } else notification.Status(response.status, this)
                })

            },
            doktorTespit(val, gelenIndex) {
                var obj = this.hekimList.find(data => data.hekimId === val);
                if (obj !== undefined) {
                    this.hastaForm.hekim[gelenIndex].doktorTelefon = obj.telefon;
                    this.hastaForm.hekim[gelenIndex].doktorEposta = obj.eposta;
                    // this.hastaForm.klinik = obj.klinik.length > 0 ? obj.klinik[0].klinikId : " ";
                    // this.klinikList = obj.klinik;
                }
            },
            hastaGuncelleme(formName) {
                var hekimList = [];
                this.$refs.hastaForm.validate((valid) => {
                    if (valid) {
                        for (var key in this.hastaKlon) {
                            if (key === 'hekim') {
                                this.hastaKlon.hekim.forEach(function (e) {
                                    hekimList.push(e.hekimId)
                                })
                                var item = {
                                    type: 'hekimId',
                                    value: hekimList
                                }
                                this.updateData.push(item);
                            } else {
                                if (this.hastaKlon[key] !== this.hastaForm[key]) {
                                    if (this.hastaForm[key] || this.hastaForm[key] === '') {
                                        item = {
                                            type: key,
                                            value: this.hastaForm[key]
                                        };
                                        this.updateData.push(item);
                                    }
                                }
                            }

                        }
                        hastaService.hastaGuncelleme(this.updateId,this.updateData).then((response) => {
                            if (response.status === 200) {
                                this.$refs.hastaForm.resetFields();
                                this.resetForm(formName);
                                EventBus.$emit("hastaList", true)
                                notification.Status('success', this, "Randevu başarıyla güncellenmiştir.");
                            }
                        });

                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "hastaguncelleme");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "hastaguncelleme") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .deleteButton {
        position: absolute;
        right: 5px;
        top: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 0 0 0 5px;
    }

    .addButton {
        position: absolute;
        right: 5px;
        bottom: 0;
        z-index: 10;
        padding: 5px;
        border-radius: 5px 0 0 0;
    }

    .esnek-kutu {
        display: flex;
        justify-content: center;
    }

    .ileriButton {
        margin-right: 3px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)
    }

    .geriButton {
        margin-left: 3px;
        box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065)
    }

    .siraNo {
        position: absolute;
        background: #9a9a9a;
        top: -5px;
        left: 0;
        border-radius: 0px 5px 5px 0px;
        padding: 5px 10px;
        color: #fff;
        font-weight: bold;
    }

</style>